import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"

type DeleteDialogProps = {
  open: boolean
  onClose: () => void
  onDelete: () => void
  children: React.ReactNode
}

export const DeleteDialog = (props: DeleteDialogProps) => {
  const { open, onClose, onDelete } = props

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Kundenkonto deaktivieren</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="error" fullWidth variant="contained" onClick={onClose}>
          Abbrechen
        </Button>
        <Button fullWidth variant="contained" onClick={onDelete} autoFocus>
          Ja
        </Button>
      </DialogActions>
    </Dialog>
  )
}
